import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Hämtar organisationens Personalliggare-inställningar.
 * Modulen är opt-in — när `enabled === false` ska UI inte visa några
 * personalliggare-element alls.
 */
export function usePersonalliggare() {
  const [state, setState] = useState({
    enabled: false,
    id06_site_number: null,
    loading: true,
    error: null,
  });

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/personalliggare/settings");
      setState({
        enabled: !!r.data?.enabled,
        id06_site_number: r.data?.id06_site_number || null,
        loading: false,
        error: null,
      });
    } catch (e) {
      setState({
        enabled: false,
        id06_site_number: null,
        loading: false,
        error: e,
      });
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { ...state, refresh };
}
